import React from 'react';
import { Outlet } from 'react-router-dom';
import { Box } from '@mui/material';
import { StyledMain, StyledPublicWrapper } from './public-layout.styles';
import { jsx as _jsx } from "react/jsx-runtime";

var PublicLayout = function PublicLayout(_ref) {
  var inline = _ref.inline;
  return /*#__PURE__*/_jsx(StyledPublicWrapper, {
    children: /*#__PURE__*/_jsx(StyledMain, {
      inline: inline,
      component: "main",
      children: inline ? /*#__PURE__*/_jsx(Outlet, {}) : /*#__PURE__*/_jsx(Box, {
        children: /*#__PURE__*/_jsx(Outlet, {})
      })
    })
  });
};

export { PublicLayout };